/* =========================================================================
   ClearHom · PDP 2 — interacciones del rediseño
   -------------------------------------------------------------------------
   Script AISLADO. No toca origin.js: las revelaciones de scroll
   (.reveal-lines / [data-reveal]), los acordeones (.pdp-acc) y el FAQ
   (.faq-item) siguen corriendo por el motor original del tema, porque el
   rediseño reutiliza esas mismas marcas de HTML a propósito.

   Aquí vive SOLO lo nuevo:
     · carruseles (galería, superficies, cabezales, para quién es)
     · texto sincronizado con el carrusel
     · pestañas del bloque de aval
     · tarjetas de aval desplegables
     · selector de variante + precio en vivo (héroe y barra fija)
   ========================================================================= */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Estado de la barra fija. Vive fuera de initSticky porque las zonas que
  // la esconden (secciones con data-p2-nosticky) se pueden registrar más
  // tarde, cuando el editor de temas vuelve a pintar una sección suelta.
  var stickyState = { bar: null, footer: false, hero: false, zones: 0 };
  function applySticky() {
    if (!stickyState.bar) return;
    stickyState.bar.classList.toggle(
      'is-hidden',
      stickyState.footer || stickyState.hero || stickyState.zones > 0
    );
  }
  var zoneObserver = null;

  function slice(x) { return Array.prototype.slice.call(x); }

  /* Trae la miniatura activa al centro de su tira, moviendo SOLO la tira.
     Nada de scrollIntoView: ese arrastra también la página en vertical. */
  function keepThumbInView(el) {
    var rail = el && el.parentElement;
    if (!rail) return;
    var max = rail.scrollWidth - rail.clientWidth;
    if (max <= 4) return;                       // caben todas: no hay nada que mover
    var target = el.offsetLeft - (rail.clientWidth - el.offsetWidth) / 2;
    target = Math.max(0, Math.min(max, target));
    if (Math.abs(target - rail.scrollLeft) < 2) return;
    if (rail.scrollTo) {
      try { rail.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' }); return; }
      catch (err) {}
    }
    rail.scrollLeft = target;
  }


  /* ---------------------------------------------------------------------
     EL MARCO SE AJUSTA A LA FOTO  (objetivos 4 y 6)
     Mide la foto que se esta viendo y escribe su proporcion real en
     --g-ratio, sobre la raiz del carrusel. El marco usa esa variable como
     `aspect-ratio`, asi que la foto lo llena de borde a borde: se acaban
     las franjas de fondo a los lados y el velo del texto cae justo sobre
     la foto, no sobre el hueco vacio.

     Se mide tambien en cuanto CADA foto termina de cargar: de lo contrario
     las primeras veces se pintaba con la proporcion de la primera foto y se
     recolocaba despues, que era el salto que se veia.
     --------------------------------------------------------------------- */
  // La proporcion de una foto se sabe ANTES de que cargue: Shopify escribe
  // width y height en cada <img>. Antes solo se miraba naturalWidth, que es
  // 0 hasta que la foto termina de bajar, asi que el marco se quedaba con la
  // forma de la foto anterior y aparecian franjas vacias a los lados.
  function ratioOf(im) {
    if (!im) return null;
    if (im.naturalWidth > 0 && im.naturalHeight > 0) return [im.naturalWidth, im.naturalHeight];
    var w = parseFloat(im.getAttribute('width'));
    var h = parseFloat(im.getAttribute('height'));
    if (w > 0 && h > 0) return [w, h];
    return null;
  }

  /* La proporcion de CADA diapositiva la escribe Liquid en su propio estilo
     (--s-ar), asi que se conoce ANTES de que la foto empiece a bajar y no
     depende de que la imagen este cargada ni de cual se midio primero. Se lee
     del atributo `style` (no de getComputedStyle) para no forzar recalculos
     de maquetacion en cada fotograma. Si falta, se cae a la foto. */
  function ratioOfSlide(slide) {
    if (!slide) return null;
    var v = 0;
    try { v = parseFloat(slide.style.getPropertyValue('--s-ar')); } catch (err) {}
    if (v > 0) return [v, 1];
    return ratioOf(slide.querySelector('img'));
  }

  function fitFrame(root, slide) {
    if (!root || !slide) return false;
    var r = ratioOfSlide(slide);
    if (!r) return false;
    root.style.setProperty('--g-ratio', r[0] + ' / ' + r[1]);
    root.classList.add('is-measured');
    return true;
  }

  /* ---------------------------------------------------------------------
     LA SOMBRA DEL TEXTO, CENIDA A LA FOTO  (sept. 2026)

     Dos fallos se arreglan aqui:

     1) El velo media lo que med:ia la CAJA DE TEXTO (max-width en `ch`), no
        la foto. Se ha separado en CSS: .p2-gallery__cap es el velo y
        .p2-gallery__cap-t es el texto. Aqui solo se coloca el velo.

     2) La medida se tomaba de la foto que hubiera cargado primero y se
        quedaba fija. Ahora cada diapositiva trae su propia proporcion
        (--s-ar, escrita por Liquid) y se recalcula MIENTRAS el marco se
        mueve, asi que el degradado sigue a la foto en vez de quedarse donde
        estaba la anterior.

     Se mide con getBoundingClientRect (decimales) y no con clientWidth
     (enteros): a 390 px de ancho, un redondeo deja una linea de velo fuera
     de la foto.
     --------------------------------------------------------------------- */
  function fitCap(slide) {
    if (!slide) return false;
    if (!slide.querySelector('.p2-gallery__cap')) return false;
    var im = slide.querySelector('img');
    // Hueco reservado sin foto: la sombra cubre la diapositiva entera.
    if (!im) { slide.classList.add('is-fit'); return true; }

    var r = ratioOfSlide(slide);
    var box = slide.getBoundingClientRect();
    var w = box.width;
    var h = box.height;
    if (!r || !w || !h) { slide.classList.remove('is-fit'); return false; }

    var fit = 'contain';
    try { fit = getComputedStyle(im).objectFit || 'contain'; } catch (err) {}

    var l = 0, t = 0;
    if (fit === 'contain' || fit === 'scale-down') {
      var sc = Math.min(w / r[0], h / r[1]);
      if (fit === 'scale-down') sc = Math.min(sc, 1);
      l = Math.max(0, (w - r[0] * sc) / 2);
      t = Math.max(0, (h - r[1] * sc) / 2);
    }
    // Un pelin hacia dentro (.5px) para que el borde del velo no asome por
    // fuera de la foto al redondear el navegador.
    l = l > 0 ? l + 0.5 : 0;
    t = t > 0 ? t + 0.5 : 0;
    slide.style.setProperty('--cap-l', l.toFixed(1) + 'px');
    slide.style.setProperty('--cap-r', l.toFixed(1) + 'px');
    slide.style.setProperty('--cap-t', t.toFixed(1) + 'px');
    slide.classList.add('is-fit');
    return true;
  }
  function fitCaps(slides) {
    for (var k = 0; k < slides.length; k++) fitCap(slides[k]);
  }

  /* ---------------------------------------------------------------------
     Carrusel genérico
     Contrato de HTML:
       [data-p2-car]                 raíz
         [data-p2-track]             pista que se desplaza
           [data-p2-slide]           cada diapositiva
         [data-p2-dot]               puntos (opcional)
         [data-p2-thumb]             miniaturas (opcional)
         [data-p2-prev] / [data-p2-next]
         [data-p2-sync]              panel de texto sincronizado (opcional)
           [data-p2-sync-head] / [data-p2-sync-body]
       data-p2-interval="3200"       autoplay en ms (0 = sin autoplay)
     --------------------------------------------------------------------- */
  function initCarousels(scope) {
    scope.querySelectorAll('[data-p2-car]').forEach(function (root) {
      if (root.dataset.p2Bound === '1') return;
      root.dataset.p2Bound = '1';

      var track  = root.querySelector('[data-p2-track]');
      var slides = slice(root.querySelectorAll('[data-p2-slide]'));
      if (!track || !slides.length) return;

      var dots   = slice(root.querySelectorAll('[data-p2-dot]'));
      var thumbs = slice(root.querySelectorAll('[data-p2-thumb]'));
      var prev   = root.querySelector('[data-p2-prev]');
      var next   = root.querySelector('[data-p2-next]');
      var sync   = root.querySelector('[data-p2-sync]');
      var syncH  = sync ? sync.querySelector('[data-p2-sync-head]') : null;
      var syncB  = sync ? sync.querySelector('[data-p2-sync-body]') : null;

      var n = slides.length;
      var i = 0;
      var interval = parseInt(root.getAttribute('data-p2-interval'), 10) || 0;
      var timer = null;

      function paintSync(k) {
        if (!sync) return;
        var s = slides[k];
        var h = s.getAttribute('data-head') || '';
        var b = s.getAttribute('data-body') || '';
        // Si no hay nada que cambiar, no parpadees.
        // innerHTML y no textContent: el titulo y la descripcion vienen ya
        // compuestos desde Liquid (snippet `mark`), asi que pueden llevar el
        // subrayado de color. Con textContent se veian las marcas == en crudo.
        if ((!syncH || syncH.innerHTML === h) && (!syncB || syncB.innerHTML === b)) return;
        if (reduce) {
          if (syncH) syncH.innerHTML = h;
          if (syncB) syncB.innerHTML = b;
          return;
        }
        sync.classList.add('is-swapping');
        setTimeout(function () {
          if (syncH) syncH.innerHTML = h;
          if (syncB) syncB.innerHTML = b;
          sync.classList.remove('is-swapping');
        }, 180);
      }

      // Solo las galerias marcadas data-p2-fitframe adaptan su marco.
      var fitsFrame = root.hasAttribute('data-p2-fitframe');
      var frame = root.querySelector('.p2-gallery__frame');

      /* SEGUIMIENTO DEL VELO (sept. 2026)
         La forma del marco va con transicion (.3s) y la pista se desliza
         (.45s): durante esos milisegundos la foto SE ESTA MOVIENDO. Medir
         una sola vez deja la sombra donde estaba la foto anterior — el
         desfase que se veia al pasar de una foto a otra. Aqui se la sigue
         fotograma a fotograma mientras dura el movimiento y el bucle se
         PARA SOLO: no queda nada corriendo de fondo.
         Solo se miden las diapositivas que llevan texto encima. */
      var capSlides = slides.filter(function (sl) {
        return !!sl.querySelector('.p2-gallery__cap');
      });
      var seguirHasta = 0, siguiendo = false;
      function ahora() {
        return (window.performance && performance.now) ? performance.now() : Date.now();
      }
      function seguirVelo(ms) {
        if (!capSlides.length) return;
        fitCaps(capSlides);
        if (!window.requestAnimationFrame) return;
        seguirHasta = Math.max(seguirHasta, ahora() + (ms || (reduce ? 120 : 800)));
        if (siguiendo) return;
        siguiendo = true;
        (function paso() {
          fitCaps(capSlides);
          if (ahora() < seguirHasta) requestAnimationFrame(paso);
          else siguiendo = false;
        })();
      }

      function render() {
        track.style.transform = 'translate3d(' + (-i * 100) + '%,0,0)';
        if (fitsFrame) fitFrame(root, slides[i]);
        seguirVelo();
        slides.forEach(function (s, x) {
          s.classList.toggle('is-active', x === i);
          // Las diapositivas fuera de pantalla no deben ser enfocables.
          s.setAttribute('aria-hidden', x === i ? 'false' : 'true');
        });
        dots.forEach(function (d, x) {
          d.classList.toggle('is-active', x === i);
          d.setAttribute('aria-current', x === i ? 'true' : 'false');
        });
        thumbs.forEach(function (t, x) {
          var on = x === i;
          t.classList.toggle('is-active', on);
          // OBJETIVO 2: si la tira de miniaturas está desplazada, la foto
          // activa podría quedar fuera de la vista al usar las flechas o el
          // deslizamiento. Se trae sola.
          // Se calcula A MANO en lugar de usar scrollIntoView: ese método
          // también mueve la página en VERTICAL, y al cargar (con el héroe
          // aún fuera de pantalla) daba un salto de scroll.
          if (on) keepThumbInView(t);
        });
        paintSync(i);
      }

      function go(k) { i = (k % n + n) % n; render(); }

      function start() {
        if (reduce || !interval) return;
        stop();
        timer = setInterval(function () { go(i + 1); }, interval);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function jump(k) { go(k); start(); }

      if (prev) prev.addEventListener('click', function () { jump(i - 1); });
      if (next) next.addEventListener('click', function () { jump(i + 1); });
      dots.forEach(function (d, x) { d.addEventListener('click', function () { jump(x); }); });
      thumbs.forEach(function (t, x) { t.addEventListener('click', function () { jump(x); }); });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      // Deslizamiento táctil
      var sx = 0, sy = 0, dragging = false, locked = false;
      root.addEventListener('touchstart', function (e) {
        // OBJETIVO 2: la tira de miniaturas vive DENTRO del carrusel. Sin
        // esta salida, arrastrarla con el dedo movía la tira Y además
        // pasaba de foto: se saltaban imágenes y parecía que la barra no
        // respondía. Las zonas marcadas data-p2-noswipe se desplazan solas.
        if (e.target && e.target.closest && e.target.closest('[data-p2-noswipe]')) {
          dragging = false;
          return;
        }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        dragging = true; locked = false; stop();
      }, { passive: true });
      root.addEventListener('touchmove', function (e) {
        if (!dragging || locked) return;
        var dx = Math.abs(e.touches[0].clientX - sx);
        var dy = Math.abs(e.touches[0].clientY - sy);
        // Si el gesto es claramente vertical, deja pasar el scroll de la página.
        if (dy > dx) { dragging = false; }
        else if (dx > 10) { locked = true; }
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (!dragging) { start(); return; }
        dragging = false;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        start();
      });

      // Cada foto avisa cuando ya se puede medir, y la sombra del texto se
      // recoloca cada vez que el marco cambia de tamano: la proporcion del
      // marco va con transicion, asi que durante esos milisegundos la foto
      // se esta moviendo y la sombra tiene que seguirla.
      // La sombra se mide SIEMPRE que haya texto sobre una foto, se adapte el
      // marco o no: si el marco lleva una forma fija y la foto no lo llena,
      // es justo cuando el degradado se salia por los lados.
      var hayCaps = !!root.querySelector('.p2-gallery__cap');
      if (fitsFrame || hayCaps) {
        slides.forEach(function (sl, x) {
          var im = sl.querySelector('img');
          if (!im) { fitCap(sl); return; }
          if (im.complete && im.naturalWidth) {
            if (fitsFrame && x === i) fitFrame(root, sl);
            fitCap(sl);
            return;
          }
          im.addEventListener('load', function () {
            if (fitsFrame && x === i) fitFrame(root, sl);
            seguirVelo(300);
          }, { once: true });
        });
        var caja = frame || track;
        if (caja && window.ResizeObserver) {
          new ResizeObserver(function () { seguirVelo(reduce ? 60 : 260); }).observe(caja);
        }
        // Las tipografias web pueden reflotar el bloque al cargar: se remide.
        if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
          document.fonts.ready.then(function () {
            if (fitsFrame) fitFrame(root, slides[i]);
            seguirVelo(300);
          });
        }
        [0, 400, 1500].forEach(function (t) {
          setTimeout(function () {
            if (fitsFrame) fitFrame(root, slides[i]);
            seguirVelo(200);
          }, t);
        });
      }

      render();
      start();
    });
  }


  /* ------------------------------ VÍDEOS -------------------------------
     CARRIL FORMATO TIKTOK (v9.2)

       · Las fichas son verticales y TODAS miden lo mismo, se este viendo
         una o ninguna. La que se reproduce NO se ensancha ni cambia de
         fila: se reproduce donde esta, asi que la tira no da ningun salto
         bajo el dedo (antes bajaba a una linea propia al ancho completo).
       · El carril se arrastra de lado: con el dedo es desplazamiento
         nativo, con el raton lo lleva [data-p2-drag], y debajo hay una
         barra que tambien se agarra.
       · No se mueve ningun nodo del DOM, asi que el <video> nunca se
         reinicia al elegir otro.
     ------------------------------------------------------------------- */
  function initVideos(scope) {
    scope.querySelectorAll('[data-p2-videos]').forEach(function (row) {
      if (row.dataset.p2Bound === '1') return;
      row.dataset.p2Bound = '1';

      var tiles = slice(row.querySelectorAll('[data-p2-vtile]'));

      function focus(tile) {
        tiles.forEach(function (t) {
          var on = t === tile;
          t.classList.toggle('is-playing', on);
          var v = t.querySelector('video');
          if (v && !on) {
            if (!v.paused) v.pause();
            v.removeAttribute('controls');
            // Se rebobina: la ficha vuelve a ser una portada limpia y la
            // proxima vez arranca desde el principio.
            try { if (v.currentTime > 0) v.currentTime = 0; } catch (err) {}
          }
          if (v && on) v.setAttribute('controls', 'controls');
        });
        row.classList.toggle('is-playing', !!tile);
      }

      // La ficha no se mueve, pero puede quedar a medias fuera del carril:
      // se centra DENTRO de la tira. A mano y no con scrollIntoView, que
      // arrastra tambien el desplazamiento vertical de la pagina.
      function center(tile) {
        if (!tile) return;
        var max = row.scrollWidth - row.clientWidth;
        if (max <= 4) return;
        var target = tile.offsetLeft - (row.clientWidth - tile.offsetWidth) / 2;
        target = Math.max(0, Math.min(target, max));
        if (Math.abs(target - row.scrollLeft) < 4) return;
        if (reduce || !row.scrollTo) { row.scrollLeft = target; return; }
        try { row.scrollTo({ left: target, behavior: 'smooth' }); }
        catch (err) { row.scrollLeft = target; }
      }

      tiles.forEach(function (tile) {
        var video = tile.querySelector('video');
        var close = tile.querySelector('[data-p2-vclose]');

        if (close) {
          close.addEventListener('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            focus(null);
          });
        }

        tile.addEventListener('click', function (e) {
          // Ya se esta viendo: los clics son para los controles nativos.
          if (tile.classList.contains('is-playing')) return;
          focus(tile);
          center(tile);
          if (video) {
            // El navegador puede rechazar la reproduccion automatica; da
            // igual, la ficha ya esta abierta y con sus controles.
            var pr = video.play();
            if (pr && pr.catch) pr.catch(function () {});
            e.preventDefault();
          }
        });

        if (!video) return;
        // Los controles solo salen en la ficha abierta: las demas son
        // portadas pulsables, no reproductores.
        video.removeAttribute('controls');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.addEventListener('play', function () { focus(tile); });
        video.addEventListener('ended', function () {
          try { video.currentTime = 0; } catch (err) {}
          focus(null);
        });
      });
    });
  }

  /* ------------------- Arrastre con el ratón (PC) -----------------------
     Las tiras horizontales (aval, miniaturas) ya se deslizan con el dedo,
     pero en PC no había forma de moverlas. Esto añade el arrastre clásico
     de "agarrar y tirar", y anula el clic si de verdad se ha arrastrado
     (si no, soltar sobre una tarjeta la abriría sin querer).
     ------------------------------------------------------------------- */
  function initDragScroll(scope) {
    scope.querySelectorAll('[data-p2-drag]').forEach(function (row) {
      if (row.dataset.p2DragBound === '1') return;
      row.dataset.p2DragBound = '1';

      var down = false, moved = false, startX = 0, startLeft = 0, id = null;

      function end() {
        if (!down) return;
        down = false;
        row.classList.remove('is-dragging');
        if (id !== null && row.releasePointerCapture) {
          try { row.releasePointerCapture(id); } catch (err) {}
        }
        id = null;
      }

      row.addEventListener('pointerdown', function (e) {
        // Solo ratón/lápiz: el dedo ya tiene el desplazamiento nativo, que
        // es más suave que cualquier cosa que hagamos aquí.
        if (e.pointerType === 'touch' || e.button !== 0) return;
        down = true; moved = false;
        startX = e.clientX;
        startLeft = row.scrollLeft;
        id = e.pointerId;
      });

      row.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) {
          moved = true;
          row.classList.add('is-dragging');
          // OJO: el apresamiento del puntero se pide AQUÍ, no en el
          // pointerdown. Si se pide antes, el navegador reasigna también el
          // `click` a la tira y las tarjetas dejan de abrirse con un clic
          // normal. Pidiéndolo solo cuando ya hay arrastre de verdad, el
          // clic simple sigue llegando a su tarjeta.
          if (row.setPointerCapture) { try { row.setPointerCapture(id); } catch (err) {} }
        }
        if (moved) {
          row.scrollLeft = startLeft - dx;
          e.preventDefault();
        }
      });

      row.addEventListener('pointerup', end);
      row.addEventListener('pointercancel', end);
      row.addEventListener('pointerleave', end);
      row.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Si se ha arrastrado, el clic que viene detrás no cuenta.
      row.addEventListener('click', function (e) {
        if (moved) {
          e.stopPropagation();
          e.preventDefault();
          moved = false;
        }
      }, true);
    });
  }

  /* --------- Tira de miniaturas: señal de "quedan fotos" (objetivo 2) ----
     Misma idea que la tira del aval, pero sin barra de progreso: la tira
     del héroe es corta y basta con el degradado del borde. Si todas las
     miniaturas caben, se marca `is-static` y el degradado desaparece: no
     se anuncia un gesto que no hace falta.
     ------------------------------------------------------------------- */
  function initThumbRails(scope) {
    scope.querySelectorAll('[data-p2-thumbrail]').forEach(function (wrap) {
      if (wrap.dataset.p2RailBound === '1') return;
      wrap.dataset.p2RailBound = '1';

      var row = wrap.querySelector('[data-p2-drag]');
      if (!row) return;

      function paint() {
        var max = row.scrollWidth - row.clientWidth;
        if (max <= 4) {
          wrap.classList.add('is-static', 'is-end');
          return;
        }
        wrap.classList.remove('is-static');
        wrap.classList.toggle('is-end', row.scrollLeft >= max - 4);
      }

      var ticking = false;
      row.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { paint(); ticking = false; });
      }, { passive: true });

      window.addEventListener('resize', paint);
      if (window.ResizeObserver) new ResizeObserver(paint).observe(row);
      paint();
      // Las miniaturas entran tarde (loading="lazy") y cambian el ancho.
      [200, 800, 2000].forEach(function (t) { setTimeout(paint, t); });
    });
  }

  /* ---------------- Tira del aval: progreso y "hay más" -----------------
     Objetivo: que ANTES de arrastrar ya se vea que hay más estudios. Se
     resuelve con tres señales que no dependen de leer nada:
       · las tarjetas son más estrechas, así siempre asoma la siguiente
         (CSS: --p2-cardw-m);
       · un degradado en el borde derecho que desaparece al llegar al final;
       · una barra de progreso que dice cuánto queda por recorrer.
     Si todo cabe sin desplazamiento, se marca `is-static` y las tres
     señales se apagan solas: no se anuncia un gesto que no hace falta.
     ------------------------------------------------------------------- */
  function initEvidenceScroll(scope) {
    scope.querySelectorAll('[data-p2-scroller]').forEach(function (wrap) {
      if (wrap.dataset.p2Bound === '1') return;
      wrap.dataset.p2Bound = '1';

      var row = wrap.querySelector('[data-p2-scrollrow]');
      var bar = wrap.querySelector('[data-p2-progbar]');
      if (!row) return;

      function paint() {
        var max = row.scrollWidth - row.clientWidth;
        if (max <= 4) {
          wrap.classList.add('is-static');
          wrap.classList.add('is-end');
          return;
        }
        wrap.classList.remove('is-static');
        var ratio = row.clientWidth / row.scrollWidth;      // parte visible
        var pos   = row.scrollLeft / max;                   // 0 -> 1
        if (bar) {
          var w = Math.max(ratio * 100, 12);
          bar.style.width = w + '%';
          // El recorrido del pulgar es el hueco que deja su propio ancho.
          bar.style.transform = 'translateX(' + (pos * (100 - w) / w * 100) + '%)';
        }
        wrap.classList.toggle('is-end', row.scrollLeft >= max - 4);
        // Si la barra es un control de verdad, dice por donde va.
        var ctl = wrap.querySelector('[data-p2-dragbar]');
        if (ctl) ctl.setAttribute('aria-valuenow', Math.round(pos * 100));
      }

      var ticking = false;
      row.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { paint(); ticking = false; });
      }, { passive: true });

      window.addEventListener('resize', paint);
      if (window.ResizeObserver) new ResizeObserver(paint).observe(row);
      // Las pestañas ocultas miden 0: se repinta al mostrarse.
      var group = row.closest('.p2-avgroup');
      if (group && window.MutationObserver) {
        new MutationObserver(paint).observe(group, { attributes: true, attributeFilter: ['class'] });
      }
      paint();
      // Las fotos entran tarde y cambian el ancho total.
      [200, 800, 2000].forEach(function (t) { setTimeout(paint, t); });
    });
  }

  /* ------------- La barra de debajo del carril SE AGARRA ----------------
     Es la senal mas clara de que la tira se puede mover: si se ve una barra
     y al tirar de ella la tira responde, no hace falta leer nada. Tambien
     responde al teclado, porque es un control y no un adorno.
     ------------------------------------------------------------------- */
  function initDragBar(scope) {
    scope.querySelectorAll('[data-p2-dragbar]').forEach(function (bar) {
      if (bar.dataset.p2Bound === '1') return;
      bar.dataset.p2Bound = '1';

      var wrap = bar.closest('[data-p2-scroller]');
      var row = wrap ? wrap.querySelector('[data-p2-scrollrow]') : null;
      if (!row) return;

      var down = false, id = null;

      function seek(clientX) {
        var r = bar.getBoundingClientRect();
        if (r.width <= 0) return;
        var thumb = bar.querySelector('[data-p2-progbar]');
        var tw = thumb ? thumb.getBoundingClientRect().width : 0;
        var travel = Math.max(1, r.width - tw);
        var pos = (clientX - r.left - tw / 2) / travel;
        pos = Math.max(0, Math.min(1, pos));
        row.scrollLeft = pos * (row.scrollWidth - row.clientWidth);
      }

      function end() {
        if (!down) return;
        down = false;
        bar.classList.remove('is-dragging');
        if (id !== null && bar.releasePointerCapture) {
          try { bar.releasePointerCapture(id); } catch (err) {}
        }
        id = null;
      }

      bar.addEventListener('pointerdown', function (e) {
        down = true;
        id = e.pointerId;
        bar.classList.add('is-dragging');
        if (bar.setPointerCapture) { try { bar.setPointerCapture(id); } catch (err) {} }
        seek(e.clientX);
        e.preventDefault();
      });
      bar.addEventListener('pointermove', function (e) {
        if (!down) return;
        seek(e.clientX);
        e.preventDefault();
      });
      bar.addEventListener('pointerup', end);
      bar.addEventListener('pointercancel', end);

      bar.addEventListener('keydown', function (e) {
        var max = row.scrollWidth - row.clientWidth;
        var step = row.clientWidth * 0.8;
        if (e.key === 'ArrowRight') row.scrollLeft = Math.min(max, row.scrollLeft + step);
        else if (e.key === 'ArrowLeft') row.scrollLeft = Math.max(0, row.scrollLeft - step);
        else if (e.key === 'Home') row.scrollLeft = 0;
        else if (e.key === 'End') row.scrollLeft = max;
        else return;
        e.preventDefault();
      });
    });
  }

  /* --------------------------- Pestañas de aval ------------------------ */
  function initTabs(scope) {
    scope.querySelectorAll('[data-p2-tabs]').forEach(function (root) {
      if (root.dataset.p2Bound === '1') return;
      root.dataset.p2Bound = '1';

      var tabs   = slice(root.querySelectorAll('[data-p2-tab]'));
      var groups = slice(root.querySelectorAll('[data-p2-group]'));
      if (!tabs.length) return;

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var g = t.getAttribute('data-p2-tab');
          tabs.forEach(function (x) {
            var on = x === t;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          groups.forEach(function (gr) {
            gr.classList.toggle('is-active', gr.getAttribute('data-p2-group') === g);
          });
        });
      });
    });
  }

  /* ------------- Tarjetas de aval -> VENTANA DEL ESTUDIO ----------------
     ANTES: la tarjeta desplegaba su resumen dentro de la propia tira y el
     resumen no era mas que un enlace, asi que "abrir un estudio" acababa
     sacando al visitante de la web. Justo cuando mas interesa que se quede.

     AHORA: la tarjeta es un boton que abre una ventana centrada con la
     ficha completa (foto, titulo, fuente, resumen, puntos clave y, como
     ultimo paso opcional, el enlace a la publicacion original).

     El contenido NO se construye aqui: Liquid ya lo ha impreso dentro de
     cada tarjeta, oculto en `.p2-avcard__full`. Este modulo solo lo clona.
     Asi el texto enriquecido, el subrayado de color y las imagenes
     responsivas siguen generandose en el servidor.
     ------------------------------------------------------------------- */
  function initStudyModal(scope) {
    scope.querySelectorAll('[data-p2-study-modal]').forEach(function (wrap) {
      if (wrap.dataset.p2Bound === '1') return;
      wrap.dataset.p2Bound = '1';

      var panel = wrap.querySelector('.p2-study');
      var body  = wrap.querySelector('[data-p2-study-body]');
      var scrl  = wrap.querySelector('.p2-study__scroll');
      if (!panel || !body) return;

      var lastFocus = null;
      var openT = null, closeT = null;

      function focusables() {
        return slice(panel.querySelectorAll(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (el) { return el.offsetParent !== null; });
      }

      function open(card) {
        var full = card.querySelector('[data-p2-study]');
        if (!full) return;

        clearTimeout(closeT);
        lastFocus = document.activeElement;

        // Se clona: la tarjeta conserva su copia para la siguiente apertura.
        body.innerHTML = '';
        slice(full.cloneNode(true).childNodes).forEach(function (n) {
          body.appendChild(n);
        });
        if (scrl) scrl.scrollTop = 0;

        wrap.hidden = false;
        document.documentElement.classList.add('p2-modal-open');
        document.body.classList.add('p2-modal-open');

        // Un fotograma de margen para que la transicion de entrada corra.
        openT = requestAnimationFrame(function () {
          requestAnimationFrame(function () { wrap.classList.add('is-open'); });
        });

        try { panel.focus({ preventScroll: true }); } catch (err) { panel.focus(); }
      }

      function close() {
        if (wrap.hidden) return;
        cancelAnimationFrame(openT);
        wrap.classList.remove('is-open');
        document.documentElement.classList.remove('p2-modal-open');
        document.body.classList.remove('p2-modal-open');

        // Se vacia DESPUES del fundido para que no parpadee al cerrarse.
        closeT = setTimeout(function () {
          wrap.hidden = true;
          body.innerHTML = '';
        }, reduce ? 0 : 340);

        if (lastFocus && lastFocus.focus) {
          try { lastFocus.focus({ preventScroll: true }); } catch (err) { lastFocus.focus(); }
        }
        lastFocus = null;
      }

      wrap.querySelectorAll('[data-p2-study-close]').forEach(function (btn) {
        btn.addEventListener('click', close);
      });

      // Teclado: Esc cierra y el tabulador no se escapa de la ventana.
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
        if (e.key !== 'Tab') return;
        var f = focusables();
        if (!f.length) { e.preventDefault(); return; }
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      });

      // La rueda del raton sobre el velo no debe mover la pagina de detras.
      wrap.addEventListener('wheel', function (e) {
        if (!scrl || scrl.contains(e.target)) return;
        e.preventDefault();
      }, { passive: false });

      // Se guarda para que las tarjetas de esta seccion sepan a quien llamar.
      wrap.__p2Open = open;
      wrap.__p2Close = close;
    });

    scope.querySelectorAll('[data-p2-card]').forEach(function (card) {
      if (card.dataset.p2Bound === '1') return;
      card.dataset.p2Bound = '1';

      function launch() {
        var sec = card.closest('.p2-evidence-sec') || document;
        var wrap = sec.querySelector('[data-p2-study-modal]');
        if (wrap && typeof wrap.__p2Open === 'function') wrap.__p2Open(card);
      }

      card.addEventListener('click', function (e) {
        // Un enlace escrito dentro del titulo o de la fuente no navega
        // (el CSS ya le quita el puntero), pero por si acaso se frena aqui.
        if (e.target && e.target.closest && e.target.closest('a')) e.preventDefault();
        launch();
      });

      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          launch();
        }
      });
    });
  }

  /* ------------------ Variantes + precio en vivo (PDP 2) --------------- */
  // El precio vive en dos sitios (héroe y barra fija) y son secciones
  // distintas, así que la actualización se hace a nivel de documento.
  //
  // El formulario se localiza por la clase `.p2-form` que le pone el propio
  // {% form %} de Shopify: los atributos data- en esa etiqueta son una fuente
  // conocida de problemas al subir el tema, así que se evitan.
  function initVariants(scope) {
    scope.querySelectorAll('.p2-form').forEach(function (form) {
      if (form.dataset.p2Bound === '1') return;
      form.dataset.p2Bound = '1';

      var dataEl = form.querySelector('[data-p2-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      if (!variants || !variants.length) return;

      var opts    = slice(form.querySelectorAll('[data-p2-opt]'));
      var idInput = form.querySelector('[data-p2-id]');

      function paint(v) {
        if (!v) return;
        if (idInput) idInput.value = v.id;

        document.querySelectorAll('[data-p2-now]').forEach(function (el) { el.textContent = v.price; });

        // POR QUE NO SALIA EL PRECIO TACHADO
        // Esto se ejecuta tambien al cargar la pagina, no solo al cambiar de
        // variante. Reescribia el tachado con el precio de comparacion real
        // del producto y, como el producto no tiene ninguno, lo dejaba vacio
        // y escondido: daba igual lo que se escribiera en el editor.
        // Ahora los importes escritos a mano van marcados data-p2-fixed y no
        // se tocan; los automaticos siguen igual que siempre.
        document.querySelectorAll('[data-p2-was]').forEach(function (el) {
          if (el.hasAttribute('data-p2-fixed')) return;
          el.textContent = v.compare_at || '';
          el.hidden = !v.on_sale;
        });
        document.querySelectorAll('[data-p2-save]').forEach(function (el) {
          if (el.hasAttribute('data-p2-fixed')) return;
          el.hidden = !v.on_sale;
        });
        document.querySelectorAll('[data-p2-save-txt]').forEach(function (el) {
          if (el.hasAttribute('data-p2-fixed')) return;
          el.textContent = 'Ahorra ' + v.save_pct + '%';
        });
        document.querySelectorAll('[data-p2-buy]').forEach(function (btn) {
          btn.disabled = !v.available;
          var lbl = btn.querySelector('[data-p2-buy-label]');
          if (lbl) {
            var base = btn.getAttribute('data-buy-base') || 'Añadir a la cesta';
            lbl.textContent = v.available ? base : 'Agotado';
          }
        });
      }

      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          opts.forEach(function (x) {
            var on = x === o;
            x.classList.toggle('is-sel', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var id = o.getAttribute('data-p2-opt');
          var found = null;
          for (var k = 0; k < variants.length; k++) {
            if (String(variants[k].id) === String(id)) { found = variants[k]; break; }
          }
          paint(found);
        });
      });

      // Estado inicial: la variante ya marcada, o la primera disponible.
      var startId = idInput ? idInput.value : null;
      var startV = null;
      for (var k = 0; k < variants.length; k++) {
        if (String(variants[k].id) === String(startId)) { startV = variants[k]; break; }
      }
      paint(startV || variants[0]);
    });
  }


  /* --------------------------- BARRA FIJA -------------------------------
     Resuelve los tres problemas reportados:
       a) la tapaban las ventanas emergentes ancladas abajo (cookies,
          newsletter): se miden y la barra se sube por encima de ellas;
       b) no dejaba leer el pie: se esconde en cuanto el footer asoma;
       c) el hueco al final de la página era fijo: ahora es su altura real.
     ------------------------------------------------------------------- */
  function initSticky(scope) {
    var bar = scope.querySelector('.p2-sticky') || document.querySelector('.p2-sticky');
    if (!bar || bar.dataset.p2Bound === '1') return;
    bar.dataset.p2Bound = '1';

    var spacer = document.querySelector('.p2-sticky-spacer');
    var root = document.documentElement;

    // (c) Altura real de la barra -> hueco reservado exacto.
    function syncHeight() {
      var h = Math.ceil(bar.getBoundingClientRect().height);
      if (h > 0) root.style.setProperty('--p2-sticky-h', h + 'px');
    }
    if (window.ResizeObserver) new ResizeObserver(syncHeight).observe(bar);

    // (a) ¿Hay otra capa fija pegada al fondo? Si la hay, nos apartamos.
    //     Se miran solo los hijos directos de <body>, que es donde las
    //     aplicaciones de Shopify inyectan sus ventanas emergentes.
    function measureOverlays() {
      var vh = window.innerHeight;
      var lift = 0;
      var kids = document.body.children;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        if (el === bar || el.contains(bar) || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;
        var cs;
        try { cs = getComputedStyle(el); } catch (err) { continue; }
        if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
        if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
        var r = el.getBoundingClientRect();
        if (r.height <= 0 || r.width <= 0) continue;
        // Pegada al fondo y sin ocupar la pantalla entera (eso sería un modal).
        if (r.bottom >= vh - 6 && r.top > vh * 0.35 && r.height < vh * 0.6) {
          lift = Math.max(lift, Math.ceil(r.height));
        }
      }
      root.style.setProperty('--p2-sticky-lift', lift + 'px');
    }

    // (b) Ocultarse al llegar al pie, mientras el botón del héroe se ve, y
    //     dentro de las secciones marcadas como "sin barra" (el carrusel de
    //     debajo del aval, por ejemplo: ahí la barra tapaba la imagen).
    var footer = document.querySelector('.ce-foot') || document.querySelector('footer');
    var heroBtn = document.querySelector('.p2-addcart');
    stickyState.bar = bar;

    if ('IntersectionObserver' in window) {
      if (footer) {
        new IntersectionObserver(function (es) {
          stickyState.footer = es[0].isIntersecting; applySticky();
        }, { rootMargin: '0px 0px -40px 0px' }).observe(footer);
      }
      if (heroBtn) {
        new IntersectionObserver(function (es) {
          stickyState.hero = es[0].isIntersecting; applySticky();
        }).observe(heroBtn);
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { measureOverlays(); syncHeight(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    // Las ventanas emergentes aparecen tarde: se vigila el <body>.
    if (window.MutationObserver) {
      new MutationObserver(onScroll).observe(document.body, { childList: true, subtree: false });
    }
    // Y un par de pasadas por si la emergente tarda unos segundos.
    [0, 600, 1800, 4000].forEach(function (t) { setTimeout(onScroll, t); });
    if (spacer) syncHeight();
  }

  /* ------------- Zonas donde la barra fija NO debe aparecer -------------
     Cualquier sección con data-p2-nosticky esconde la barra mientras esté
     en pantalla. Es lo que pedía el carrusel de debajo del aval: la barra
     tapaba la imagen justo cuando hay que mirarla.

     Se cuentan las zonas visibles (no se usa un simple sí/no) para que dos
     secciones seguidas no dejen asomar la barra a mitad de camino.
     ------------------------------------------------------------------- */
  function initNoSticky(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (!zoneObserver) {
      zoneObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var was = en.target.dataset.p2ZoneIn === '1';
          var now = en.isIntersecting;
          if (was === now) return;
          en.target.dataset.p2ZoneIn = now ? '1' : '0';
          stickyState.zones += now ? 1 : -1;
          if (stickyState.zones < 0) stickyState.zones = 0;
        });
        applySticky();
      }, { threshold: 0, rootMargin: '-25% 0px -25% 0px' });
    }
    scope.querySelectorAll('[data-p2-nosticky]').forEach(function (z) {
      if (z.dataset.p2ZoneBound === '1') return;
      z.dataset.p2ZoneBound = '1';
      z.dataset.p2ZoneIn = '0';
      zoneObserver.observe(z);
    });
  }

  /* ------------------ Barra fija: enviar el formulario del héroe ------- */
  // Si la barra fija no tiene su propio formulario, reenvía al del héroe
  // para que se añada exactamente la misma variante seleccionada.
  function initStickyProxy(scope) {
    scope.querySelectorAll('[data-p2-sticky-proxy]').forEach(function (btn) {
      if (btn.dataset.p2Bound === '1') return;
      btn.dataset.p2Bound = '1';
      btn.addEventListener('click', function () {
        var form = document.querySelector('.p2-form');
        if (form && typeof form.requestSubmit === 'function') form.requestSubmit();
        else if (form) form.submit();
      });
    });
  }

  /* ------------------------------ Arranque ----------------------------- */
  function boot(scope) {
    initCarousels(scope);
    initTabs(scope);
    initStudyModal(scope);
    initDragScroll(scope);
    initThumbRails(scope);
    initEvidenceScroll(scope);
    initDragBar(scope);
    initVideos(scope);
    initSticky(scope);
    initNoSticky(scope);
    initVariants(scope);
    initStickyProxy(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Editor de temas de Shopify: se ha vuelto a pintar una sección.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
